export enum AssessmentType {
  QUIZ = "QUIZ",
  TEST = "TEST",
  MIDTERM_EXAM = "MIDTERM_EXAM",
  FINAL_EXAM = "FINAL_EXAM",
  HOMEWORK = "HOMEWORK",
  PROJECT = "PROJECT",
  CLASS_PARTICIPATION = "CLASS_PARTICIPATION",
  PRACTICAL = "PRACTICAL",
}
